$(document).ready(function() {
  
  // check if close megamenu function
  function windowScrolled(offset) {
    if (offset > 0) {
      $(".site-nav__dropdown").addClass("header-scrolled"); 
    } else if (offset === 0) {
      $(".site-nav__dropdown").removeClass("header-scrolled");
    }
  }
  
  // close megamenu dropdown if scrolled
  $(window).on("scroll", function() {
    var top = $(window).scrollTop();
    windowScrolled(top);
  });
  
  setTimeout(function() {
  $(".stamped-summary-actions-newreview").html("Skriv anmeldelse");
  $("li#tab-reviews").html("Anmeldelse(r)");
  $(".stamped-sort-select").remove();
  $(".stamped-form-contact-name input").attr("placeholder", "Dit navn");
  $(".stamped-form-contact-email input").attr("placeholder", "din@mail.dk");
  $(".stamped-form-review-title input").attr("placeholder", "Overskrift");
  $("#stamped-button-submit").attr("value", "Send anmeldelse");
  }, 1500);
});